import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { media } from 'styles/utils';

const Row = styled.div.attrs(
  ({
    align,
    breakpoint,
    colGap,
    gap,
    justify,
    layout,
    rowGap,
    wrap,
    ...props
  }) => ({
    ...props,
    $align: align,
    $breakpoint: breakpoint,
    $colGap: colGap ?? gap ?? 0,
    $justify: justify,
    $layout: layout,
    $rowGap: rowGap ?? gap ?? 0,
    $wrap: wrap,
  })
)`
  align-content: start;
  align-items: ${(p) => p.$align};
  column-gap: ${(p) => p.$colGap};
  display: flex;
  justify-content: ${(p) => p.$justify};
  row-gap: ${(p) => p.$rowGap};
  max-width: 100%;

  ${({ $wrap }) => $wrap && `flex-wrap: wrap;`}

  ${({ $breakpoint }) =>
    $breakpoint &&
    css`
      ${media.max($breakpoint)} {
        flex-wrap: wrap;
      }
    `}

  ${({ $layout }) =>
    $layout === 'fixed' &&
    `
    & > * {
      flex: 1 1 100%;
    }
    `}
`;

export default Row;

Row.propTypes = {
  align: PropTypes.string,
  breakpoint: PropTypes.string,
  colGap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  justify: PropTypes.string,
  layout: PropTypes.oneOf(['fixed', 'auto']),
  rowGap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wrap: PropTypes.bool,
};

Row.defaultProps = {
  align: 'stretch',
  breakpoint: 'md',
  justify: 'center',
  layout: 'fixed',
};
